import { Box } from '@mui/material';
import List from '../../Components/List/List';
import React from 'react';
import { useGithub } from '../../hooks/useGithub';


export default function Repos(){
    const { repos } = useGithub();

    return (
        <Box sx={{ width: '100%', height: '100%' }}>
            <List items={repos}/>
        </Box>
    );
}